import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';

async function getConfigAvancadas(): Promise<any> {
  const api = await getApi();
  const { data } = await api.get<any>('/indice_valor/avancado/', {});
  return data;
}

type QueryFnType = typeof getConfigAvancadas;

function useConfigAvancadas() {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-config-avancadas-indice', ],
    queryFn: () =>  getConfigAvancadas(),
  });
}

export { useConfigAvancadas };
